import http from "@services/httpService"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import type {
  GetNotificationDeliveryInput,
  NotificationDeliveryDashboardDto,
  NotificationDeliveryLogDto,
} from "@services/notification/dto/notificationDeliveryDto"

/**
 * Client REST cho Delivery Tracking, bọc `httpService` (axios) theo URL ABP
 * `/api/services/app/NotificationDelivery/{Method}` và envelope `{ result, success }`.
 *
 * Quy ước ABP dynamic Web API: method tiền tố `Get*` → HTTP GET (params trên query).
 * Tham chiếu: Requirements 11.5, 11.6, 11.7 (accounting-notification-settings).
 */
class NotificationDeliveryService {
  private readonly baseUrl = "api/services/app/NotificationDelivery"

  /** Danh sách delivery log có phân trang + lọc (thời gian, loại, trạng thái, kênh) (R11.5). */
  public async getAll(
    input: GetNotificationDeliveryInput
  ): Promise<PagedResultDto<NotificationDeliveryLogDto>> {
    const res = await http.get(`${this.baseUrl}/GetAll`, { params: input })
    return res.data.result
  }

  /** Chỉ số tổng hợp dashboard (tổng gửi, %success/fail/read, avg retry) + danh sách (R11.6). */
  public async getDashboardMetrics(
    input: GetNotificationDeliveryInput
  ): Promise<NotificationDeliveryDashboardDto> {
    const res = await http.get(`${this.baseUrl}/GetDashboardMetrics`, {
      params: input,
    })
    return res.data.result
  }
}

export default new NotificationDeliveryService()
